import { Component, OnInit } from '@angular/core';
import { ElementRef, NgZone, QueryList, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-estadistics-reason',
  templateUrl: './estadistics-reason.component.html',
  styleUrls: ['./estadistics-reason.component.scss'],
  standalone: true
})
export class EstadisticsReasonComponent implements OnInit {

  @ViewChildren('counter', { read: ElementRef }) counters!: QueryList<ElementRef<HTMLElement>>;

  constructor(private ngZone: NgZone) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.observeCounters(), 300);
  }

  private observeCounters(): void {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return;
    }

    if (!this.counters || this.counters.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target as HTMLElement;
            this.startCounter(element);
            observer.unobserve(element);
          }
        });
      },
      { threshold: 0.1 }
    );

    this.counters.forEach(counter => {
      observer.observe(counter.nativeElement);
    });
  }

  private startCounter(el: HTMLElement): void {
    const targetAttr = el.getAttribute('data-target');
    const prefix = el.getAttribute('data-prefix') || '';
    const suffix = el.getAttribute('data-suffix') || '';
    const target = targetAttr ? Number(targetAttr) : 0;

    if (!target) return;

    this.ngZone.runOutsideAngular(() => {
      let startTime: number | null = null;
      const duration = 1500;

      const step = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.floor(eased * target);

        el.innerText = `${prefix}${current}${suffix}`;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.innerText = `${prefix}${target}${suffix}`;
        }
      };

      requestAnimationFrame(step);
    });
  }

}
